{
  "name": "freewheel",
  "type": "adapter",
  "tech": "js",
  "author": "Nice People At Work",
  "version": "6.8.5",
  "built": "2023-11-29",
  "repo": "https://bitbucket.org/npaw/freewheel-adapter-js",
  "libVersion": "^6.8.28",
  "features": {
    "buffer": "monitor",
    "seek": "monitor",
    "error": true,
    "stop": true,
    "pause": true,
    "resume": true,
    "getters": [
      "getPlayhead",
      "getDuration",
      "getTitle",
      "getResource",
      "getPlayerVersion",
      "getPosition",
      "getGivenBreaks",
      "getBreaksTime",
      "getGivenAds",
      "getIsVisible",
      "getAudioEnabled",
      "getCreativeId"
    ]
  },
  "ads": []
}